"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-control-regex */
exports.default = /\b[\w.-]+@[\w.-]+\.\w{2,4}\b/gi;
//# sourceMappingURL=emailRegex.js.map